import React, { FC } from 'react'
import { ResponseReportApplicationMember } from '../../../../states/types/analyze'
import { format } from '../../../../utils/date'
import CsvModule from '../CsvModule'
import TableList from '../TableList'

interface Props {
  date: string
  list: ResponseReportApplicationMember
}

const MemberApplication: FC<Props> = (props) => {
  const {
    date,
    list,
  } = props

  return (
    <>
      {
        list.data.length ? (
          <section className="page_contents content-area">
            <div className="content-block">
              <div className="block-header">
                <div className="title">
                  ユーザーリスト
                </div>
                <CsvModule
                  title={
                    `ITガバナンス - ユーザー ${format(date, "YYYY年MM月")}`
                  }
                  labels={{
                    member_name: "メンバー",
                    service_name: "アプリケーション",
                    category_name: "分類名",
                    use_days: "期間内利用日数",
                    oldest_use_date: "期間内初回利用日",
                    latest_use_date: "期間内最終利用日",
                    use_time: "期間内利用時間",
                    biz_point: "合計Biz",
                  }}
                  list={list.data.map((v) => ({ ...v, service_name: v.company_service_name || v.service_name }))}
                />
              </div>
              <div className="block-detail">
                <div className="grid_area">
                  <div className="grid_block no_border">
                    <TableList
                      labels={{
                        member_name: "メンバー名",
                        service_name: "アプリ名",
                        category_name: "分類名",
                        use_days: "期間内利用日数",
                        oldest_use_date: "期間内初回利用日",
                        latest_use_date: "期間内最終利用日",
                        use_time: "期間内利用時間",
                        biz_point: "合計Biz",
                      }}
                      list={list.data.map((v) => ({ ...v, service_name: v.company_service_name || v.service_name }))}
                      displayLimit={15}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        ) : (
          <div className="no_data_area">
            <div className="no_data_title">
              データがありません
            </div>
            <div className="no_data_text">
              期間条件や絞り込み条件をご確認ください。
            </div>
          </div>
        )
      }
    </>
  )
}

export default MemberApplication
